export default "__VITE_ASSET__DWAo_3pY__"